<div [id]="getId()" class="modal fade" role="dialog" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>

            <div class="modal-body">
                <div class="buttons">
                    <a [href]="applicationStateService.bookConfig.listLink" class="btn btn-round btn-open btn-semibold">
                        zur Buchliste der Digi.Bücher
                    </a>
                </div>

                <app-book-additionals></app-book-additionals>
                @if (usedMaterials && usedMaterials.length > 0) {
                    <h4>Zuletzt verwendete Materialien</h4>
                    <div class="edition-switcher-used-books">
                        <ul class="used-additionals">
                            @for (usedMaterial of usedMaterials; track usedMaterial) {
                                @for (file of usedMaterial.files; track file) {
                                    <li>
                                        <a [attr.href]="file.link"
                                           [attr.title]="file.title"
                                           data-bs-placement="right"
                                           data-bs-toggle="tooltip"
                                           data-bs-trigger="hover"
                                           target="_blank">
                                            <img [src]="usedMaterial.cover" alt="Bookcover"/>
                                            <span [position]="'0 3px'"
                                                  [size]="'auto 25px'"
                                                  [url]="usedMaterial.typeIconUrl"
                                                  backgroundImage>
                                                @if (file.isExcel) {
                                                    Excel
                                                }
                                                @if (file.isWord) {
                                                    Word
                                                }
                                                @if (file.isPdf) {
                                                    PDF
                                                }
                                            </span>
                                        </a>
                                    </li>
                                }
                            }
                        </ul>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
